<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>
<script>
    import router from 'vue-router'
    import './assets/scss/style.scss'
    import './assets/style.min.css'
    import 'vue-datetime/dist/vue-datetime.css'
    import Login from './components/auth/Login'
    import Header from './components/Header'
    import Preloader from './components/Preloader';
    import Sidebar from './components/Sidebar';
    import Base from './views/Base';

    export default {
        name: 'app',
        components: {
            Base,
            Preloader,
            Login,
            Header,
            Sidebar,
            router,
        }

    }
</script>
<style lang="scss">
    html, body {
        height: 100%;
    }

    #app {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

</style>
